
const send = function(message) {
	const promise = new Promise((resolve, reject) => {
		const req = () => {
			const headers = {
				'Content-Type': 'application/json',
				"Authorization": "Bearer MIEOASLJBNNFKP65HIHEG5QIYFRM6H3X"
			}

			fetch("https://api.wit.ai/message?v=20240710&q="+encodeURIComponent(message), {
				method: "GET",
				headers
			})
			.then((response) => response.text())
			.then((textout) => {
				try {
					resolve(processResponse(JSON.parse(textout)));
				} catch(jsonerr) {
					reject({"status":"Error", "details": jsonerr, "message": textout});
				}
			})
			.catch( (error) => {
				reject( error )
			})
		}
		return req();
	})

	return promise
}

const processResponse = function(jsonresponse) {
	var action = "";
	var detail = "";
	var tmpidx = 0;
	var finalmsg = "";
	var buttonlist = [];

	if (jsonresponse.hasOwnProperty("status")) {
		if (jsonresponse.status === "Error") {
			return {
				"action": "",
				"detail": "",
				"message": "Sorry, there's some error in the chat.  May you try again later or contact our live agents instead?",
				"button": []
			}
		}
	}

	if (jsonresponse.intents.length > 0) {
		var hasgreeting = false;
		var curmax = 0;
		var maxaction = "";
		tmpidx = 0;
		while (tmpidx < jsonresponse.intents.length) {
			if (jsonresponse.intents[tmpidx].name === "GREETING") {
				hasgreeting = true;
			} else if (curmax < jsonresponse.intents[tmpidx].confidence) {
				curmax = jsonresponse.intents[tmpidx].confidence;
				maxaction = jsonresponse.intents[tmpidx].name;
			}
			tmpidx++;
		}
		action = maxaction;
		if (hasgreeting) {
			finalmsg = (new Date()).getHours()>11?"Good afternoon!":"Good morning!";
			if (action.length < 1) {
				action = "GREETING";
			}
		}
	}
	if (action === "" || action === "PRICELIST" || action === "HOWTOORDER") {
		if (jsonresponse.entities.hasOwnProperty("wit$search_query:search_query")) {
			const nonsearchwords = ["price", "list", "how", "to", "order", "pick", "up"];
			var tmpquerywords = [];
			var tmpquerywordsidx = 0;
			var tmpquerylist = jsonresponse.entities["wit$search_query:search_query"];
			// Search ?
			tmpidx = 0;
			while (tmpidx < tmpquerylist.length) {
				tmpquerywords = tmpquerylist[tmpidx].value.toLowerCase().split(" ");
				tmpquerywordsidx = 0;
				while (tmpquerywordsidx < tmpquerywords.length) {
					if (nonsearchwords.includes(tmpquerywords[tmpquerywordsidx]) === false) {
						detail = " "+tmpquerywords[tmpquerywordsidx];
					}
					tmpquerywordsidx++;
				}
				tmpidx++;
			}
			if (detail.length > 0) {
				action = "SEARCH";
				detail = detail.substring(1);
			}
		}
	}

	if (action === "SEARCH") {
		finalmsg = finalmsg + " Do you want to see search/price results for '"+detail+"'?";
		buttonlist = [
			{
				"label":"Yes please",
				"url":"/search?search_query="+encodeURIComponent(detail)
			}
		];
	} else if (action === "COURIERSERVICE") {
		finalmsg = finalmsg + " Customers selecting a pickup point for their order at negosyonow.com may arrange their own third-party logistics (e.g., Lalamove, Grab) for collection, provided the selected supplier offers this option. Please note that the customer is responsible for booking and directly paying for the courier service. When placing your order, select the desired pickup point and indicate your preferred courier for item retrieval. Thank you.:)";
		buttonlist = [
			{
				"label":"Pick up Transactions",
				"url":"/pick-up-transactions"
			},
			{
				"label":"Similar Questions",
				"url":"/faq"
			}
		];

	} else if (action === "DELIVERYMODES") {
		// Bus shipping
		finalmsg = finalmsg + " Some sellers offer direct delivery to Metro Manila and neighboring provinces and some offer pick up options in bus terminals. Please note that service options depend on the specific seller and order.:) These details will be made available to you upon check out.";
		buttonlist = [
			{
				"label":"Bus Shipping",
				"url":"/pick-up-transactions/#bus-shipping"
			},
			{
				"label":"Similar Questions",
				"url":"/faq"
			}
		];

	} else if (action === "DELIVERYRATES") {
		finalmsg = finalmsg + " Negosyonow partners with various sellers. Please be aware that delivery fees can differ between sellers. :)";
		buttonlist = [
			{
				"label":"Pick up",
				"url":"/pick-up-transactions"
			},
			{
				"label":"Bus Shipping",
				"url":"/pick-up-transactions/#bus-shipping"
			},
			{
				"label":"Similar Questions",
				"url":"/faq"
			}
		];
	} else if (action === "HOWTOORDER") {
		finalmsg = finalmsg + " You may look at our Products page use the search bar to add items that you want to order. For any other inquiries or concerns you might have, please don't hesitate to contact Ms. Khim at 09671677484 or Ms. Apple at 09176218246. We're happy to assist you!";
		buttonlist = [
			{
				"label":"Delivery",
				"url":"/howto/negosyonow-tutorials-ordering-for-delivery/"
			},
			{
				"label":"Pick up",
				"url":"/pick-up-transactions"
			},
			{
				"label":"Bus Shipping",
				"url":"/pick-up-transactions/#bus-shipping"
			},
			{
				"label":"Videos",
				"url":"/howto"
			}
		];
	} else if (action === "LOCATION") {
		finalmsg = finalmsg + " We collaborate with numerous sellers through our platform. Although we do not have physical storefronts, some of our suppliers provide collection points for convenient order pickup. This option is subject to seller availability. :)";
		//https://negosyonow.com/pick-up-transactions/#pick-up

		buttonlist = [
			{
				"label":"Location Maps",
				"url":"/pick-up-transactions/#pick-up"
			},
			{
				"label":"Pick up",
				"url":"/pick-up-transactions"
			},
			{
				"label":"Bus Shipping",
				"url":"/pick-up-transactions/#bus-shipping"
			}
		];
	} else if (action === "MINIMUMORDER") {
		finalmsg = finalmsg + " Minimum order quantities can differ between sellers. After you submit your order, the Negosynow Team will contact you in case that your order does not meet the minimum order required by your chosen seller and guide you through the next steps. :)";
		buttonlist = [
			{
				"label":"Pick up",
				"url":"/pick-up-transactions"
			},
			{
				"label":"Bus Shipping",
				"url":"/pick-up-transactions/#bus-shipping"
			},
			{
				"label":"Delivery",
				"url":"/howto/negosyonow-tutorials-ordering-for-delivery/"
			},
			{
				"label":"Similar Questions",
				"url":"/faq"
			}
		];
	} else if (action === "PAYMENTOPTIONS") {
		finalmsg = finalmsg + " Negosyonow partners with various sellers. Please be aware that payment methods, including Cash on Delivery and bank transfers, can differ between sellers. :)";
		buttonlist = [
			{
				"label":"Pick up",
				"url":"/pick-up-transactions"
			},
			{
				"label":"Bus Shipping",
				"url":"/pick-up-transactions/#bus-shipping"
			},
			{
				"label":"Delivery",
				"url":"/howto/negosyonow-tutorials-ordering-for-delivery/"
			},
			{
				"label":"Similar Questions",
				"url":"/faq"
			}
		];
	} else if (action === "PRICELIST") {
		finalmsg = finalmsg + " You may look at our Products page use the search bar to see items' pricees.  Our sellers are free to offer different pricing for different customers. Apply to be a dealer or franchisee of their products to get additional discounts and perks through checking our franchising page - https://negosyonow.com/franchise/ . In case that the sellers do not have a franchise or dealer program, it would seem that the prices that are indicated in the website are their final prices :)";
		buttonlist = [
			{
				"label":"Products",
				"url":"/category"
			},
			{
				"label":"Franchise",
				"url":"/franchise"
			}
		];
	} else if (action === "RESELLEROPTION") {
		finalmsg = finalmsg + " Hi, we currently don't have wholesale/reseller price, but feel free to order from us and add on to our price. :) We also have Franchise packages available! :)";
		buttonlist = [
			{
				"label":"Products",
				"url":"/category"
			},
			{
				"label":"Franchise",
				"url":"/franchise"
			}
		];
	} else if (action === "WHOLESALEPRICE") {
		finalmsg = finalmsg + " Our sellers are free to offer different pricing for different customers. Apply to be a dealer or franchisee of their products to get additional discounts and perks through checking our franchising page - https://negosyonow.com/franchise/ . In case that the sellers do not have a franchise or dealer program, it would seem that the prices that are indicated in the website are their final prices :)";
		buttonlist = [
			{
				"label":"Products",
				"url":"/category"
			},
			{
				"label":"Franchise",
				"url":"/franchise"
			}
		];
	} else if (action === "THANK") {
		finalmsg = finalmsg + " You're welcome! :)";
	} else if (action === "GREETING") {
		finalmsg = finalmsg + " How may I help you?";
	}
	if (finalmsg.length > 0) {
		if (finalmsg.substring(0, 1) === " ") {
			finalmsg = finalmsg.substring(1);
		}
	}

	return {
		"action": action,
		"detail": detail,
		"message": finalmsg.length < 1? "I'm sorry I don't understand.  Do you want to try talking with an agent?": finalmsg,
		"button": buttonlist
	}

/*

OK
{
	"entities": {
		"wit$search_query:search_query": [
			{
				"body": "hello",
				"confidence": 0.9380599856376648,
				"end": 5,
				"entities": {},
				"id": "666601684984599",
				"name": "wit$search_query",
				"role": "search_query",
				"start": 0,
				"suggested": true,
				"type": "value",
				"value": "hello"
			}
		]
	},
	"intents": [
		{
			"confidence": 0.9969660579784085,
			"id": "678448644325594",
			"name": "GREETING"
		}
	],
	"text": "hello",
	"traits": {}
}


Not OK
{
	"entities": {
		"wit$location:location": [
			{
				"body": "river",
				"confidence": 0.8899099826812744,
				"end": 56,
				"entities": {},
				"id": "1257000788353177",
				"name": "wit$location",
				"role": "location",
				"start": 51,
				"suggested": true,
				"type": "value",
				"value": "river"
			}
		],
		"wit$search_query:search_query": [
			{
				"body": "quick",
				"confidence": 0.653243788497231,
				"end": 9,
				"entities": {},
				"id": "666601684984599",
				"name": "wit$search_query",
				"role": "search_query",
				"start": 4,
				"suggested": true,
				"type": "value",
				"value": "quick"
			},
			{
				"body": "brown fox jumps over",
				"confidence": 0.999,
				"end": 30,
				"entities": {},
				"id": "666601684984599",
				"name": "wit$search_query",
				"role": "search_query",
				"start": 10,
				"suggested": true,
				"type": "value",
				"value": "brown fox jumps over"
			},
			{
				"body": "lazy dog",
				"confidence": 0.8921849727630615,
				"end": 43,
				"entities": {},
				"id": "666601684984599",
				"name": "wit$search_query",
				"role": "search_query",
				"start": 35,
				"suggested": true,
				"type": "value",
				"value": "lazy dog"
			}
		]
	},
	"intents": [],
	"text": "the quick brown fox jumps over the lazy dog by the river!",
	"traits": {}
}

// Search
{
	"entities": {
		"wit$search_query:search_query": [
			{
				"body": "fries",
				"confidence": 0.9380900263786316,
				"end": 17,
				"entities": {},
				"id": "666601684984599",
				"name": "wit$search_query",
				"role": "search_query",
				"start": 12,
				"suggested": true,
				"type": "value",
				"value": "fries"
			}
		]
	},
	"intents": [
		{
			"confidence": 0.9591981568436051,
			"id": "2109825176026785",
			"name": "PRICELIST"
		}
	],
	"text": "do you have fries",
	"traits": {}
}

*/
}

module.exports = {
	send
};